import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { IphoneComponent } from './iphone.component';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { PermissionLevel } from '../shared/permission/permission';
import { VersionGuard } from '../shared/guards/version-guard';

export const iphoneRoutes: Array<DynamicRoute> = [
  {
    path: 'iphone',
    component: IphoneComponent,
    canActivate: [VersionGuard, PermissionGuard],
    data: {
      show: NeverShowRouteResolver,
      title: 'iphone',
      permissionLevel: PermissionLevel.MANAGER,
      type: []
    }
  }
];
